import BaseComponentController from "../base_component_controller"

import '../../../../../../../vendor/assets/javascripts/ckeditor/init' // Keep the old way to initialize CKEditor

export default class extends BaseComponentController {
  static targets = ['textarea', 'inlineContainer']

  static values = {
    inline: Boolean,
    language: String,
    options: Object
  }

  connect() {
    if (this.inlineValue) {
      this.ckeditor = CKEDITOR.inline(this.inlineContainerTarget, this.ckeditorOptions)
    } else {
      this.ckeditor = CKEDITOR.replace(this.textareaTarget, this.ckeditorOptions)
    }

    this.prepareEvents()
  }

  disconnect() {
    if (this.ckeditor) {
      this.ckeditor.destroy(true)
    }
  }

  prepareEvents() {
    this.ckeditor.on('change', (e) => {
      if (this.inlineValue) {
        this.textareaTarget.value = this.ckeditor.getData()
      }

      this.dispatchEvent({ target: this.textareaTarget, action: 'ck:change', options: { detail: { ckeditorEvent: e } } })
    })

    this.ckeditor.on('key', (e) => this.dispatchEvent({ target: this.textareaTarget, action: 'ck:key', options: { detail: { ckeditorEvent: e } } }))
    this.ckeditor.on('instanceReady', (e) => this.dispatchEvent({ target: this.textareaTarget, action: 'ck:instanceReady', options: { detail: { ckeditorEvent: e } } }))
    this.ckeditor.on('instanceReady', (e) => this.dispatchEvent({ target: this.textareaTarget, action: 'ck:paste', options: { detail: { ckeditorEvent: e } } }))
  }

  get ckeditorOptions() {
    return {
      language: this.languageValue,
      ...this.optionsValue
    }
  }
}
